import { CompanyServiceType } from "@vahak/core/dist/constants/serviceTypeId";
import { LoginFormFieldsTypes, initialLoginFormValues } from "../../common/contant";

interface BuildLoginFormInitialValuesParams {
    phoneNum?: string | number;
    referralCode?: string;
    globalData?: { userPlaceInfo?: { place_id?: string } };
    defaultPlaceId?: string;
    defaultServiceType?: CompanyServiceType;
}

/** Geolocation first, then flow default (e.g. load source), then empty. */
export function resolveLoginFormPlaceId(
    globalData?: { userPlaceInfo?: { place_id?: string } },
    defaultPlaceId?: string
) {
    return globalData?.userPlaceInfo?.place_id || defaultPlaceId || "";
}

export function buildLoginFormInitialValues({
    phoneNum,
    referralCode,
    globalData,
    defaultPlaceId,
    defaultServiceType
}: BuildLoginFormInitialValuesParams): LoginFormFieldsTypes {
    return {
        ...initialLoginFormValues,
        phoneNumber: phoneNum ?? "",
        referralCode: referralCode ?? "",
        serviceType: defaultServiceType,
        showCurrentLocationField: true,
        currentPlaceID: resolveLoginFormPlaceId(globalData, defaultPlaceId)
    } as LoginFormFieldsTypes;
}
